
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    let supportsPassive = false;
    try {
      const opts = Object.defineProperty({}, 'passive', {
        get: function () {
          supportsPassive = true;
        }
      });
      window.addEventListener('test', null, opts);
    } catch (e) { }
    window.addEventListener('touchstart', function (event) {
    }, supportsPassive ? { passive: true } : false);
    window.addEventListener('touchmove', function (event) {
    }, supportsPassive ? { passive: true } : false);
    window.addEventListener('wheel', function (event) {
    }, supportsPassive ? { passive: true } : false);
    if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
      handleFontSize();
    } else {
      if (document.addEventListener) {
        document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
      } else if (document.attachEvent) {
        document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
      }
    }
    function handleFontSize() {
      // 设置网页字体为默认大小
      WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize': 0 });
      // 重写设置网页字体大小的事件
      WeixinJSBridge.on('menu:setfont', function () {
        WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize': 0 });
      });
      console.log('设置字体大小')
    }
    if (import.meta.env.MODE !== 'development') {
      setInterval(function () {
        var startTime = performance.now();
        // 设置断点
        debugger;
        var endTime = performance.now();
        // 设置一个阈值，例如100毫秒
        if (endTime - startTime > 100) {
          window.location.href = 'about:blank';
        }
      }, 1000);
    }
  